import { createSelector } from "reselect";

import reducerRegistry from "../../util/reducerRegistry";
import {
  REDUCER_NAME,
  RESET_COMPETITIONSEASONS,
  SET_COMPETITIONSEASONS,
  SET_ERROR,
} from "./constants";

const initialState = {
  isReady: false,
  isError: false,
  seasons: [],
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_COMPETITIONSEASONS:
      return {
        ...state,
        isReady: true,
        isError: false,
        seasons: action.data,
      };
    case RESET_COMPETITIONSEASONS:
      return initialState;
    case SET_ERROR:
      return {
        ...state,
        isReady: false,
        isError: true,
      };
    default:
      return state;
  }
};

const getState = (state) => {
  if (state[REDUCER_NAME]) {
    return state[REDUCER_NAME];
  }
  return initialState;
};

export const selectIsReady = createSelector(getState, (n) => n.isReady);

export const selectIsError = createSelector(getState, (n) => n.isError);

export const selectCompetitionSeasons = createSelector(getState, (n) =>
  n.seasons.reverse()
);

reducerRegistry.register(REDUCER_NAME, reducer);
